module.exports = __webpack_public_path__ + "img/cloud-download-fill.ee220214.svg";